/**
 * 用户登录与注册相关操作，用户登录后的个人操作不要写在这里
 * @author wanghui
 * @date 2020/01/06
 */

import Utils from '../js/utils/utils'
import Global from '../js/global'

import { QRCodeLogin } from '../js/qrcodeLogin'  // app 扫码登录

import '../css/login.css'
import '../css/qrcodeLogin.css'

const tpl = $('#tpl_now').text();
let isMine = false;
let qrcodelogin = new QRCodeLogin();

if (tpl.indexOf('mine') > -1) {
    isMine = true;
    require('../js/ucenter');
}

$(function () {
    $('#pop_mask').css('height', document.body.scrollHeight + 'px');

    if (Utils.Cookies.getItem('GWD_USER_TOKEN')) {
        if (! isMine) {
            Global.getUserInfo({isUpdate: true,}, (res) => {    // logined

                    if (['user_login', 'user_register'].indexOf(tpl) >= 0) {
                        window.location.href = Utils.UrlParams().from_url ? Utils.UrlParams().from_url : (Utils.UrlParams().from || '/');
                        return;
                    }

                    let $userMenu = $('.header_new .top-nav #user-menu');
                    $userMenu.children().remove();
                    $userMenu && $userMenu.append(
                        $('<li>', {
                            class: 'item fl',
                        }).append(
                            $('<a>', {
                                href: '/mine?from=top-nav',
                                class: 'hui666',
                                target: '_blank'
                            }).text(Utils.Cookies.getItem('plt_user_nk'))
                        )
                    ).append(
                        $('<li>', {
                            class: 'item fl ml-10'
                        }).text('欢迎回到购物党！')
                    ).append(
                        $('<li>', {
                            class: 'item fl ml-20'
                        }).append(
                            $('<a>', {
                                href: '/mine/setting',
                                class: 'hui666',
                                target: '',
                            }).html('消息<span style="color:#CC0236">(' + 0 + ')</span>')
                        )
                    ).append(
                        $('<li>', {
                            class: 'item fl ml-10 hui333',
                            id: 'logout',
                        }).append(
                            $('<a>', {
                                href: 'javascript:;',
                                class: 'hui999'
                            }).text('退出')
                        )
                    ).show();

                    $('.myStore .hover-menu .item:nth-child(1)')
                        .attr('href', '/mine')
                        .attr('target', '_blank')
                        .removeClass('pop_login')
                        .html('<i class="icon i-user mr-5 pos_r vm"></i>个人中心');
                },
                () => {
                    notLogined();
                });
        }
    } else {
        notLogined();
    }

    // 设置第三方登录
    if (['user_login', 'user_register'].indexOf(tpl) >= 0) {
        $(".container .oauth-login .oauth-list .oauth-item").each(function () {
            generateSocialMediaAuthUrl($(this))
        });
    }

    // 密码找回-邮箱找回验证email
    if ('user_forgot_pwd' === tpl) {
        let $step1 = $('.form-section .step-imgs').find('.step-1.active');
        let capi = $('.form-section #input-validate-email[data-step=\'1\']').data('capi');
        if ($step1.length && capi) {
            Utils.HttpRequest.get(capi, null, {crossDomain: true,}, (res) => {
                if (res.code == 1) {
                    $('.section-wrapper .form-section').children('.step-imgs').children('.step-2').addClass('active').siblings().removeClass('active');
                    $('.form-section #input-validate-email[data-step=\'1\']').hide();
                    $('.form-section #input-validate-email[data-step=\'2\']').show();
                } else {
                    $('.section-wrapper .form-section').children('.step-imgs').children('.step-1').addClass('active').siblings().removeClass('active');
                    $('.form-section #input-validate-email, .form-section #to-validate-email, .form-section .bind-result').hide();
                    $('.form-section .bind-result-error').show();
                }
            });
        }
    }
});

// 登录方式切换
$('.header .login-section-title').on('click', function () {
    if (! $(this).hasClass('active') && ! $(this).hasClass('locked')) {
        let position_left = 29;

        if ($(this).attr('id') === 'form-reg') { position_left = 21; }
        if ($(this).attr('id') === 'form-login') { position_left = 39; }

        $(this).addClass('active').siblings('.login-section-title').removeClass('active')
            .siblings('.section-active-sign')
            .animate({
                left: $(this).position().left + position_left + 'px',
            }, 'fast');

        if ($(this).attr('for')) {
            $(".section-wrapper .form-section#" + $(this).attr('for')).show().siblings('.form-section').hide();
            $('.area-login .section-wrapper .login-errors, #pop_login .section-wrapper .login-errors').hide();
        }

        if ('user_register' === tpl && 'section-account' === $(this).attr('for')) {
            $('.section-wrapper .section-account .sec-code .seccode-img').attr('src', Utils.secCodeImg());
        }

        if ('section-qrcode' === $(this).attr('for')) {
            let $qrcodeWrapper = $(this).parents('.header').siblings('.section-wrapper').children('.section-qrcode');

            $(this).parents('#pop_login').find('.agreement').hide();

            if ($(this).parents('#pop_login').length) {
                $qrcodeWrapper.css('padding-top', '8px');
            }

            qrcodelogin.create($qrcodeWrapper, true);
        } else {
            $(this).parents('#pop_login').find('.agreement').show();
        }
    }
});

$('.input-action.pwd-eye').on('click', function () {
    $(this).toggleClass('opened');
    $(this).siblings('input[name=password],input[name=confirm_password]').attr('type', $(this).hasClass('opened') ? 'text' : 'password' );
});

$('.input-action.input-del').on('click', function () {
    $(this).hide().siblings('input').val('');
});

$('.section-wrapper .form-section input').keyup(function () {
    let $del = $(this).siblings('.input-action.input-del');
    if ($del.length) {
        $(this).val().trim().length ? $del.show() : $del.hide();
    }

    $(this).parents('.section-wrapper').find('.login-errors').hide();
    $(this).siblings('.tips').hide();
});

// 关闭登录弹窗
$("#pop_login_close, #pop_mask").click(function () {
    $('#pop_mask').hide();

    let $pop_login = $('#pop_login');
    $pop_login.hide();

    $pop_login.find('.header .login-section-title:nth-child(1)').addClass('active').siblings('.login-section-title').removeClass('active');
    $pop_login.find('.header .section-active-sign').css('left', '83px');
    $pop_login.find('.section-wrapper .section-phone').show();
    $pop_login.find('.section-wrapper .section-phone').siblings().hide();
    $pop_login.find('.section-wrapper input').val('');
    $pop_login.find('.section-wrapper .btn-send-code').removeClass('disabled').attr('disabled', false);


    if ($('.section-wrapper .section-qrcode').length) {
        $pop_login.find('.header .section-active-sign').css('left', '53px');
        $pop_login.find('.agreement').show();
    }

    // 滑块验证
    window.captchaCallbackOK();
});

// 记住我
$('.section-wrapper .form-section .input-item.remember input#remember-me').change(function () {
    $(this).parent().toggleClass('remembered');

    if (tpl !== 'user_login') {
        $(this).parents('.form-section#section-account').find('.input-item.email, .input-item.password').toggleClass('remembered');
    }
});

// 发送验证码
$('.section-wrapper .form-section .btn-send-code').on('click', function () {
    let $phone = $(this).parents('.form-section').find('.input-item.phone input[id=phone]');
    let $loginErr = $(this).parents('.section-wrapper').find('.login-errors') || null;
    let sms_tag = $(this).data('sms-tag');
    let sms_from = $(this).data('sms-from') || '';

    if (tpl === 'mine_setting_phone') {
        $phone = $(this).parents('#input-validate-email').children('.input-item#phone').find('input[name=phone]');
    }

    if (sms_tag === 'register') {
        $loginErr = $(this).siblings('.login-errors');
    }

    if (sms_tag === 'bind' || sms_tag === 'change' || sms_tag === 'rechange') {
        $loginErr = $(this).siblings('.tips');
    }

    $loginErr && $loginErr.hide();
    $(this).parents('.form-section').find('.input-item .tips').hide();

    if (Utils.Validator.validatePhone($phone.val())) {
        sendSMS($(this), $phone.val(), sms_tag, (res) => {
            if (res.code == 0) {    // 滑块验证码
                if (sms_from === 'popup-login') {
                    let $captcha = Utils.createSmallCaptcha(res.data.link);
                    $(this).parents('.section-wrapper').hide().siblings('.agreement').hide();
                    $(this).parents('.section-wrapper').siblings('.other_platform').css('margin-top', '0');
                    $captcha.insertAfter($(this).parents('.section-wrapper'));

                    $(this).parents('#pop_login').children('.header').find('.login-section-title').addClass('locked');
                } else {
                    Utils.createPopupCaptcha(res.data.link);
                }
            } else {
                if (sms_tag === 'register') {
                    $(this).siblings('.login-errors').show().children('span').text(res.msg);
                } else if (sms_tag === 'login') {
                    $(this).parents('.section-wrapper').children('.login-errors').show().find('span').text(res.msg);
                } else {
                    $(this).siblings('.tips').text(res.msg).show();
                }
            }
        })
    } else {
        if (sms_tag === 'register') {
            $(this).parents('.input-item').siblings('.input-item#phone').children('.login-errors').show().children('span').text('请输入正确的手机号码');
        } else if (['forgot', 'bind', 'change', 'rechange'].indexOf(sms_tag) > -1) {
            $(this).parents('.input-item').siblings('.input-item#phone').children('.tips').text('请输入正确的手机号码').show();
        } else {
            if ($loginErr) {
                $loginErr.show().children('span').text('请输入正确的手机号码');
            }
        }
        $phone.focus();
    }
});

// 退出登录
$('.top-nav #user-menu').on('click', '.item#logout a', (e) => {
    Global.doLogout(() => {
        let href = $(this).data('href');
        if (href) {
            window.location.href = href;
        } else if (['mine_collection'].indexOf(tpl) > -1) {
            window.location.href = '/';
        } else {
            window.location.reload();
        }
    });
});

// 登录/密码找回
$('.section-wrapper .btn-login:not(.btn-register)').on('click', function (e) {
    if (['mine_setting_email', 'mine_setting_phone', 'user_register', 'mine_setting_password'].indexOf(tpl) > -1) {
        return ;
    }
    e.preventDefault();

    // 忘记密码-验证身份1
    if ('user_forgot_pwd' === tpl) {
        let step = $(this).parents('#input-validate-email').data('step');

        if (step == 1) {
            let type = $(this).siblings('.input-item#phone').find('label span').text().trim();
            let $phone = $(this).siblings('.input-item#phone').find('input#phone');
            let $code = $(this).siblings('.input-item#phone-code').find('input#phone-code');
            let smsCApi = $(this).siblings('.input-item#phone-code').find('input#sms-capi').val().trim();

            $phone.siblings('.tips').hide();
            $code.siblings('.tips').hide();

            if (type === '手机号' && ! Utils.Validator.validatePhone($phone.val().trim())) {
                $phone.siblings('.tips').show().text('请输入正确的手机号码');
                $phone.focus();
                return ;
            }

            if (type === '邮箱' && ! Utils.Validator.validateEmail($phone.val().trim())) {
                $phone.siblings('.tips').show().text('请输入正确的邮箱');
                $phone.focus();
                return ;
            }

            if (! $code.val().trim().length) {
                $code.siblings('.tips').text('验证码错误，请重新输入').show();
                $code.focus();
                return ;
            }

            if (type === '手机号') {
                if (! smsCApi) {
                    $code.siblings('.tips').text('验证码错误，请重新输入').show();
                    return ;
                }

                Utils.HttpRequest.post(smsCApi, {code: $code.val().trim()}, {crossDomain: true,}, res => {
                    if (res.code == 1) {
                        $(this).parents('#input-validate-email').hide().siblings('#input-validate-email[data-step=2]').show();
                        $(this).parents('.form-section').children('.step-imgs').find('.step.step-2').addClass('active').siblings().removeClass('active');
                    } else {
                        $code.siblings('.tips').text(res.msg).show();
                    }
                }, err => {});
            } else {
                Utils.checkSecCode({
                    op: 'seccode',
                    seccode: $code.val().trim(),
                }, {}, () => {  // success
                    let email = $phone.val().trim();
                    Global.checkEmail({
                        email: email,
                        tag: 'forgot',
                    }, (res) => {   // email发送成功
                        $(this).parents('#input-validate-email').hide().siblings('#to-validate-email').show();
                        $(this).parents('#input-validate-email').siblings('#to-validate-email').find('p:nth-child(1) span').text(email);

                        if (Utils.isCommonEmail(email.split('@')[1])) {
                            $(this).parents('#input-validate-email').siblings('#to-validate-email').find('.btn-href-login').attr('href', 'https://mail.' + email.split('@')[1]);
                            $(this).parents('#input-validate-email').siblings('#to-validate-email').find('.uncommon-email').hide();
                        } else {
                            $(this).parents('#input-validate-email').siblings('#to-validate-email').find('.btn-href-login').hide();
                            $(this).parents('#input-validate-email').siblings('#to-validate-email').find('.uncommon-email').show();
                        }
                    }, (err) => {
                        $phone.siblings('.tips').show().text(err.msg);
                    })
                }, () => {  // fail
                    $code.siblings('.tips').text('验证码错误，请重新输入').show();
                });
            }
        } else if (step == 2) {
            let $password = $(this).siblings('.input-item#password');
            let $repassword = $(this).siblings('.input-item#repassword');
            let type = $(this).parents('#input-validate-email').siblings('#input-validate-email[data-step=1]').find('.input-item#phone label span').text().trim();

            let data = {
                new_passwd: $password.children('input#password').val().trim(),
                new_repasswd: $repassword.children('input#repassword').val().trim(),
                tag: 'forgot',
            };

            $password.find('.tips').hide();
            if (data.new_passwd.length < 6) {
                $password.find('.tips').text('密码至少6个字符').show();
                return ;
            }

            $repassword.find('.tips').hide();
            if (data.new_repasswd !== data.new_passwd) {
                $repassword.find('.tips').text('两次密码不一致').show();
                return ;
            }

            Global.resetPasswd(data, (res) => {
                if (res.code == 1) {
                    $(this).parents('.form-section').children('.step-imgs').find('.step.step-3').addClass('active').siblings().removeClass('active');
                    $(this).parents('.form-section').children('.bind-result').show().siblings(':not(.step-imgs)').hide();
                } else {
                    $repassword.find('.tips').text(err.msg).show();
                }
            }, err => {
                $repassword.find('.tips').text(err.msg).show();
            })
        }
    } else {
        // 账号登录
        if ($(this).hasClass('loading')) {
            return ;
        }

        let loginType = $(this).data('login-type');
        let loginFrom = $(this).parents('.section-wrapper').data('login-from');
        let $loginErr = $(this).parents('.section-wrapper').find('.login-errors') || null;
        let loginData = {};

        $loginErr.hide();

        if (loginType === 'account') {
            loginData = {
                account: $(this).parents('.form-section').find('input[name=account]').val().trim(),
                password: $(this).parents('.form-section').find('input[name=password]').val().trim(),
                remember_me: $(this).parents('.form-section').find('input[name=remember_me]').is(':checked') ? 1 : 0,
            };

            if (! Utils.Validator.validateEmail(loginData.account) && ! Utils.Validator.validatePhone(loginData.account)) {
                $loginErr && $loginErr.show().children('span').text('账户或密码错误，请重新输入');
                $(this).parents('.form-section').find('input[name=account]').focus();
                return ;
            }

            if (loginData.password.length < 6) {
                $loginErr && $loginErr.show().children('span').text('账户或密码错误，请重新输入');
                $(this).parents('.form-section').find('input[name=password]').focus();
                return ;
            }

            if (loginData.password.length > 14) {
                $loginErr && $loginErr.show().children('span').text('账户或密码错误，请重新输入');
                $(this).parents('.form-section').find('input[name=password]').focus();
                return ;
            }
        }

        if (loginType === 'phone') {
            loginData = {
                phone: $(this).parents('.form-section').find('input[name=phone]').val().trim(),
                code:  $(this).parents('.form-section').find('input[name=code]').val().trim(),
                smsCApi: $(this).parents('.form-section').find('input#sms-capi').val().trim(),
            };

            if (! Utils.Validator.validatePhone(loginData.phone)) {
                $loginErr && $loginErr.show().children('span').text('请输入正确的手机号码');
                $(this).parents('.form-section').find('input[name=phone]').focus();
                return ;
            }

            if (! loginData.code) {
                $loginErr && $loginErr.show().children('span').text('验证码错误，请重新输入');
                $(this).parents('.form-section').find('input[name=code]').focus();
                return ;
            }

            if (! loginData.smsCApi) {
                $loginErr && $loginErr.show().children('span').text('验证码错误，请重新输入');
                return ;
            }
        }

        $(this).addClass('loading');
        doLogin(loginType, loginData, loginFrom, (res) => {
            if (res.code == -1) {
                res.msg && $loginErr && $loginErr.show().children('span').text(res.msg);
                $(this).removeClass('loading');
            } else {
                let from = Utils.UrlParams().from;

                if (['user_login', 'user_register'].indexOf(tpl) >= 0) {
                    if (! from && Utils.UrlParams().from_url) {
                        from = Utils.UrlParams().from_url;
                    }

                    if (! from) from = '/';
                    window.location.href = from;
                } else {
                    window.location.reload();
                }
            }
        })
    }
});

// 注册
$(".container#register .area-login .section-wrapper .btn-login:not(.reg-to-login)").on('click', function (e) {
    e.preventDefault();
    let regType = $(this).data('reg-type');
    let regData = {};

    $(this).parents('.form-section').find('.login-errors').hide();
    $(this).parents('.form-section').find('.tips-txt').hide();

    let $passwd = null;
    let $rePasswd = null;
    let dataError = false;
    let seccode = '';

    if (regType === 'account') {
        let $nickname = $(this).parents('.form-section').find('input[name=nickname]');
        let $email = $(this).parent('.form-section').find('input[name=email]');
        seccode = $(this).parents('.form-section').find('.input-item.sec-code input[name=seccode]').val().trim();
        $passwd = $(this).parents('.form-section').find('input[name=password]');
        $rePasswd = $(this).parents('.form-section').find('input[name=confirm_password]');

        regData = {
            rtype: 'email',
            nickname: $nickname.val().trim().replace(/\s/g, ''),
            email: $email.val().trim().replace(/\s/g, ''),
            passwd: $passwd.val().trim().replace(/\s/g, ''),
            repasswd: $rePasswd.val().trim().replace(/\s/g, ''),
        };

        if (regData.nickname.length < 2) {
            $nickname.siblings('.login-errors').show().children('span').text('昵称不少于2字符');
            dataError = true;
        } else if (regData.nickname.length > 20) {
            $nickname.siblings('.login-errors').show().children('span').text('昵称不超过20字符');
            dataError = true;
        } else {
            $nickname.siblings('.tips-icon').show();
        }

        if (! Utils.Validator.validateEmail(regData.email)) {
            $email.siblings('.login-errors').show().children('span').text('请输入正确的邮箱');
            dataError = true;
        } else {
            $email.siblings('tips-icon').show();
        }

        if (seccode.length < 4) {
            $(this).parents('.form-section').find('.input-item.sec-code .login-errors').show();
            dataError = true;
        }
    }

    if (regType === 'phone') {
        let $nickname = $(this).parents('.form-section').find('input[name=nickname]');
        let $phone = $(this).parent('.form-section').find('input[name=phone]');
        let $code = $(this).parent('.form-section').find('input[name=code]');
        let $smsCApi = $(this).parent('.form-section').find('input#sms-capi');
        $passwd = $(this).parents('.form-section').find('input[name=password]');
        $rePasswd = $(this).parents('.form-section').find('input[name=confirm_password]');

        regData = {
            rtype: 'phone',
            nickname: $nickname.val().trim().replace(/\s/g, ''),
            passwd: $passwd.val().trim().replace(/\s/g, ''),
            repasswd: $rePasswd.val().trim().replace(/\s/g, ''),
            phone_number: $phone.val().trim().replace(/\s/g, ''),
            smscode: $code.val().trim().replace(/\s/g, ''),
            sms_capi: $smsCApi.val().trim().replace(/\s/g, ''),
        };

        if (regData.nickname.length < 2) {
            $nickname.siblings('.login-errors').show().children('span').text('昵称不少于2字符');
            // $nickname.focus();
            dataError = true;
        } else if (regData.nickname.length > 20) {
            $nickname.siblings('.login-errors').show().children('span').text('昵称不超过20字符');
            // $nickname.focus();
            dataError = true;
        } else {
            $nickname.siblings('.tips-icon').show();
        }

        if (! Utils.Validator.validatePhone(regData.phone_number)) {
            $phone.siblings('.login-errors').show().children('span').text('请输入正确的手机号码');
            // $phone.focus();
            dataError = true;
        }

        if (regData.smscode.length < 4 || ! regData.sms_capi.length) {
            $code.siblings('.login-errors').show().children('span').text('验证码错误，请重新输入');
            // $code.focus();
            dataError = true;
        } else {
            $code.siblings('.tips-icon').show();
        }
    }

    if (regData.passwd.length < 6) {
        $passwd.siblings('.login-errors').show().children('span').text('密码至少6个字符');
        dataError = true;
    }

    if (regData.passwd.length > 14) {
        $passwd.siblings('.login-errors').show().children('span').text('密码不超过14个字符');
        dataError = true;
    }

    if (regData.repasswd !== regData.passwd) {
        $rePasswd.siblings('.login-errors').show().children('span').text('两次密码不一致');
        dataError = true;
    }

    if (dataError) {
        return ;
    }

    if (regType === 'phone') {
        doRegister(regType, regData, (res, regType) => {
            if (res.code == -1) {
                $(this).siblings('.input-item.phone').find('.login-errors').show().children('span').text(res.msg);
            } else if (res.code == 1) {
                let from = Utils.UrlParams().from ? Utils.UrlParams().from : '/';
                window.location.href = from;

                // let loginData = {
                //     account: regData.phone_number,
                //     password: regData.passwd,
                //     remember_me: 1,
                // };
                // $(this).hide();
                // // $(this).siblings('.reg-to-login').attr('href', '/user/login?from=' + encodeURIComponent(from)).css('display', 'block');
                //
                // doLogin('account', loginData, 'form_login', (loginRes) => {
                //     if (loginRes.code == 1) {
                //         window.location.href = from;
                //     } else {
                //         alert(loginRes.msg);
                //     }
                // });
            }
        })
    } else {
        Utils.checkSecCode({
            seccode: seccode
        }, {}, () => {  // success
            doRegister(regType, regData, (res, regType) => {
                if (res.code == -1) {
                    $(this).siblings('.input-item.email').find('.login-errors').show().children('span').text(res.msg);
                } else if (res.code == 1) { // email发送成功
                    $(this).parents('.container#register').hide();
                    let $d = $(this).parents('.container#register').siblings('.container#email-validation');
                    $d.find('.section-wrapper h1 span').text(regData.email);

                    if (Utils.isCommonEmail(regData.email.split('@')[1])) {
                        $d.find('.section-wrapper .btn-validate').attr('href', 'https://mail.' + regData.email.split('@')[1]);
                    } else {
                        $d.find('.uncommon-email').show();
                        $d.find('.section-wrapper .btn-validate').hide();
                    }

                    $d.find('.section-wrapper .check_mail_notice .resend-status span').text(regData.email);
                    $d.find('.section-wrapper .btn-resend-email').on('click', () => {
                        resendEmail({
                            tag: 'register',
                            email: regData.email
                        });
                    });
                    $d.show();
                }
            })
        }, () => {  // fail
            $(this).parents('.form-section').find('.input-item.sec-code .login-errors').show();
        });
    }
});

// 收藏夹toggle
$('.myStore .hover-menu').hover(function () {
    if (Utils.Cookies.getItem('GWD_USER_TOKEN')) {
        if ($(this).find('.item:not(:nth-child(1))').length === 0) {
            $(this).append('<a href="/mine/collection" target="_blank" class="item hui333 font12 tc">收藏夹</a>');
            $(this).append('<a href="/mine/price_protect" target="_blank" class="item hui333 font12 tc">价保订单</a>');
            $(this).append('<a href="/mine/credit" target="_blank" class="item hui333 font12 tc">账户积分</a>');
            $(this).append('<a href="/mine/setting" target="_blank" class="item hui333 font12 tc">个人设置</a>');
        }

        $(this).find('.item:not(:nth-child(1))').show();
    }
}, function () {
    $(this).find('.item:not(:nth-child(1))').hide();
});

/**
 * 未登录状态下的一些操作
 */
let notLogined = () => {
    $(".top-nav .menu#user-menu .item#login-box dd a").each(function () {
        generateSocialMediaAuthUrl($(this))
    });

    $(".form_contaner#pop_login .other_platform .other-logos .logo-item").each(function () {
        generateSocialMediaAuthUrl($(this))
    });

    $('.myStore .hover-menu .item:not(:nth-child(1))').remove();
};

// 注册时重新发送email
let resendEmail = (data) => {
    Global.checkEmail(data, (res) => {
        $(".container#email-validation .section-wrapper .check_mail_notice .resend-status").show();
    }, (err) => {
        $(".container#email-validation .section-wrapper .check_mail_notice .resend-status").show().text(err.msg);
    });
};

// 忘记密码-选择手机号或邮箱找回
$('.form-section#section-bind #input-validate-email #phone label').on('click', function () {
    $(this).toggleClass('active');

    $(this).hasClass('active') ? $(this).siblings('.label-txt-list').show() : $(this).siblings('.label-txt-list').hide();
});

// 忘记密码-选择手机号或邮箱
$('.form-section .label-txt-list').on('click', '.label-item', function () {
    let label = $(this).text().trim();

    if (label !== $(this).parents('.label-txt-list').siblings('label').children('span').text().trim()) {
        $(this).addClass('active').siblings().removeClass('active');
        $(this).parents('.label-txt-list').siblings('label').children('span').text(label);
        $(this).parents('.label-txt-list').siblings('input').val('').siblings('.input-action.input-del').hide();

        $(this).parents('.form-section').find('.tips').hide();
        $(this).parents('.input-item').siblings('.input-item').find('input').val('');
    }

    $(this).parents('.label-txt-list').hide().siblings('label').toggleClass('active');

    if (label === '邮箱') {
        $(this).parents('.input-item').siblings('#phone-code').children('.seccode').show().siblings('.btn-send-code').hide();
        $(this).parents('.input-item').siblings('#phone-code').children('.seccode').children('.seccode-img').attr('src', Utils.secCodeImg());
    }

    if (label === '手机号') {
        $(this).parents('.input-item').siblings('#phone-code').children('.seccode').hide().siblings('.btn-send-code').show();
    }
});

// 刷新验证码
$('.seccode').on('click', function () {
    $(this).children('.seccode-img').attr('src', Utils.secCodeImg());
});

// 发送邮件后，返回上一步
$('.form-section#section-bind #to-validate-email .back').on('click', function () {
    let step = $(this).parent().data('step') || '1';
    $(this).parent().hide().siblings(`#input-validate-email[data-step='${step}']`).show();
});

// 手机号输入数字限制
$('.section-wrapper .form-section .input-item.phone input[name=phone]').on('input', Utils.Inputing.Number);

/**
 * 生成第三方登录的地址
 * @param $dom
 * @param sign 手动传入参数
 * @param success 成功回调
 */
let generateSocialMediaAuthUrl = function ($dom, sign, success) {
    if (! sign || ! Object.keys(sign).length) {
        sign = {
            ac: 'UserUnion.Authorize'.toLowerCase(),
            utype: $dom.data('oauth-type'),
            platform: 'pc',
            t: (new Date().getTime() / 1e3).toFixed(0),
        }
    }

    let from = Utils.UrlParams().from_url;
    if (from) {
        sign._refer = from;
    }

    let sign_str = Utils.DataSign(sign);
    delete sign['ac'];
    let data_arr = [];
    if (sign._refer) {
        if (Utils.UrlParams().ext && Utils.UrlParams().ext == 1) {
            Utils.Cookies.setItem('_referer', sign._refer, 3600 * 3, '/', '.gwdang.com');
        }
        sign._refer = encodeURIComponent(sign._refer);
    }
    Object.keys(sign).forEach((k) => {
        data_arr.push(k + '=' + sign[k])
    });
    data_arr.push('sign=' + sign_str);
    $dom.attr('href', 'https://i.gwdang.com/UserUnion/Authorize?' + data_arr.join('&'));

    success && 'function' === typeof success && success();
};

/**
 * 发送短信验证码
 * @param $el
 * @param phoneNumber
 * @param tag
 * @param callback
 */
let sendSMS = ($el, phoneNumber, tag, callback) => {
    if (! phoneNumber ) return;
    tag = tag || 'login';
    if (tag === 'register') tag = 'login';

    let sendValidateCodeInterval = 60;
    let options = {
        isSign: true,
        ac:'UserHelper.SmsCode',
        crossDomain: true,
    };
    let data = {
        phone: phoneNumber,
        tag: tag,
    };

    Utils.HttpRequest.post('https://i.gwdang.com/UserHelper/SmsCode', data, options, (response) => {
        if (response.code == 1) {
            $el.siblings('#sms-capi').val(response.data.capi);

            let sendValidateCodeTimer = setInterval(() => {
                if (sendValidateCodeInterval) {
                    sendValidateCodeInterval --;
                    $el.addClass('disabled').text(sendValidateCodeInterval + 's').attr('disabled', true);
                } else {
                    sendValidateCodeInterval = 60;
                    $el.removeClass('disabled').text('发送验证码').attr('disabled',false);
                    clearInterval(sendValidateCodeTimer)
                }
            }, 1e3);
        } else {
            callback && 'function' === typeof callback && callback(response)
        }
    });
};

/**
 * 账号登录，手机快捷登录
 * @param loginType
 * @param data
 * @param loginFrom
 * @param callback
 */
let doLogin = (loginType, data, loginFrom, callback) => {
    loginType = loginType || 'account';
    data = data || {};
    let loginData = {};
    let options = {
        isSign: true,
        ac: 'User.Login',
        crossDomain: true,
    };
    let u = 'https://i.gwdang.com/User/Login';
    if (loginType === 'account') {
        loginData = {
            account: data.account,
            passwd: data.password,
            remember_me: data.remember_me,
        };
    } else if (loginType === 'phone') {
        loginData = { code: data.code, };
        u = data.smsCApi;
        options.isSign = false;
        options.ac = 'UserUnion.AuthorizeCallback';
    }

    Utils.HttpRequest.post(u, loginData, options, function (response) {
        callback && 'function' === typeof callback && callback(response);
    })
};

/**
 * 账号注册
 * @param regType
 * @param data
 * @param callback
 */
let doRegister = (regType, data, callback) => {
    regType = regType || 'account';
    data = data || {};
    let regData = data;
    if (! regData.platform) regData.platform = 'pc';

    let options = {
        isSign: true,
        ac: 'User.Register',
        crossDomain: true,
    };
    let u = 'https://i.gwdang.com/User/Register';
    if (regType === 'phone') {
        delete regData['sms_capi'];
    }

    Utils.HttpRequest.post(u, regData, options, (response) => {
        callback && 'function' === typeof callback && callback(response, regType);
    })
};

/**
 * 获取用户收藏列表
 * @param data
 * @param success
 */
let getCollectionList = (data, success) => {
    $.ajax({
        url: '/app/collection?rand=' + new Date().getTime(),
        dataType: 'json',
        data: {
            format: 'json',
        },
        success: function (response) {
            success && 'function' === typeof success && success(response);
        }
    })
};

/**
 * 滑块验证成功回调处理
 */
window.captchaCallbackOK = function () {
    $('.popup-captcha').length && $('.popup-captcha').remove();

    if ($('.small-captcha').length) {
        let $capt = $('.small-captcha');
        $capt.siblings('.section-wrapper').show();
        $capt.siblings('.agreement').show();
        $capt.siblings('.other_platform').css('margin-top', '36px');
        $('#pop_login .login-section-title').removeClass('locked');
        $capt.remove();
    }
};

/**
 * 滑块验证成功回调处理（跨域fallback）
 * postMessage方式
 */
window.addEventListener('message', function (event) {
    if (event.data === 'success') {
        $('.popup-captcha').length && $('.popup-captcha').remove();

        if ($('.small-captcha').length) {
            let $capt = $('.small-captcha');
            $capt.siblings('.section-wrapper').show();
            $capt.siblings('.agreement').show();
            $capt.siblings('.other_platform').css('margin-top', '36px');
            $('#pop_login .login-section-title').removeClass('locked');
            $capt.remove();
        }
    }
}, false);